import { css } from '@emotion/react';
import * as React from 'react';

import { ConditionalBlurWrapper } from '~src/blur/conditional-blur-wrapper';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { Heading } from '~src/ui/heading';

export const BillingAddressManagerLayout: React.FC<
  React.PropsWithChildren<React.PropsWithChildren>
> = ({ children }) => {
  const { tICU } = useTranslations();
  return (
    <ConditionalBlurWrapper css={styles.layout}>
      <Heading>{tICU('widget.BILLING_ADDRESS_HEADER')}</Heading>
      {children}
    </ConditionalBlurWrapper>
  );
};

const styles = {
  layout: css({
    position: 'relative',
    marginTop: '12px',
    marginBottom: '16px',
  }),
};
